import React, { useEffect, useMemo, useState } from "react"
import { Table, Row, Col, Card, CardBody, Form,Container } from "reactstrap"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
import { Link, useNavigate } from "react-router-dom"
import Swal from "sweetalert2"
import swal from "sweetalert"
// import { Container, UncontrolledDropdown, DropdownToggle, DropdownMenu, Form, Input, Label } from "reactstrap"
// import Breadcrumbs from "../../../components/Common/Breadcrumb"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
// css
// import '../../../assets/css/Settings/Setting.css';
// import "../../../assets/css/Finance/Style/PayrollManagement/payroll_management.css"

// commom
import Pagination from "components/Common/Pagination"

import { CSVLink } from "react-csv"
import configure from "configure"
import { Modal } from "bootstrap/dist/js/bootstrap.bundle.min"
import NewPagination from "components/Common/Newpagination"

function TableContainer({ columns, data }) {
  const [fixedContent, setFixedContent] = useState(false)
  const [formPopup, setFormPopup] = useState(false)

  // const [salaryCalculation, setSalaryCalculation] = useState(false);

  const navigate = useNavigate()

  document.addEventListener("scroll", () => {
    if (window.scrollY > 256) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: "id", // Set the ID of the first column for default sorting
            desc: true, // `true` for descending, `false` for ascending
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  // Functionality to export table data to CSV //
  const excelColumns = []
  columns.forEach(column => {
    excelColumns.push(column.Header)
  })

  const csvData = [
    excelColumns,
    ...data.map(
      ({ id, date, title, invoiceNo, customer, category, debit, credit }) => [
        id,
        date,
        title,
        invoiceNo,
        customer,
        category,
        debit,
        credit,
      ]
    ),
  ]
  // ======================================================= //

  const handleSalaryCalculation = async () => {
    Swal.fire({
      title: "Are you sure to calculate salary?",
      icon: "warning",
      text: "if confirm then it will take around 1 to 2 minutes. please don't refresh the page",
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then(willOkay => {
      if (willOkay.isConfirmed) {
        Swal.fire({
          icon: "success",
          text: "Calculation Successfully Completed",
        })
      }
    })
  }

  const handleAccessPreview = async () => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      text: "Are you sure you want grant access punching preview to employees ?",
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then(willOkay => {
      if (willOkay.isConfirmed) {
        Swal.fire({
          icon: "success",
          text: "Punching preview is granted for employees",
        })
      }
    })
  }

  // Render the UI for your table
  return (
    <div>
      {/* fixed buttons */}
      {/* <div className={`flex-column fixed-buttons ${fixedContent ? 'd-flex' : 'd-none'}`}>
                <CSVLink
                    className='btn btn-success border-radius fix-btn'
                    filename="gst_ztpl.csv"
                    data={csvData}>
                    <i className='fas fa-download me-2 icon-center'></i>
                    <span>Export</span>
                </CSVLink>

                <button onClick={() => navigate(-1)} className='btn btn-red border-radius fix-btn' >
                    <i className='dripicons-cross me-2 icon-center'></i>
                    <span>Cancel</span>
                </button>
            </div> */}
      <Row className="mb-2">
        <Col md={12} className="mb-4">
          <h5 className="text-dark">Punch Details</h5>
          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="d-flex flex-column">
              <h6>Import Sheet</h6>
              <div className="d-flex">
                <div className="">
                  <input
                    id="search-bar-0"
                    type="file"
                    className="border-radius form-control rounded h-100"
                    placeholder={` Search...`}
                  />
                </div>
                <div className="ms-3">
                  <button className="border-radius btn text-white me-2 btn-purple">
                    Import
                  </button>
                </div>
              </div>
            </div>

            <div>
              <button
                onClick={() => handleSalaryCalculation()}
                className="border-radius btn text-white me-2 btn-purple"
              >
                Salary Calculations
              </button>
              <button
                onClick={() => handleAccessPreview()}
                className="border-radius btn text-white  btn-purple"
              >
                Access To Preview
              </button>
            </div>
          </div>
        </Col>
        <Col>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {50}
              </option>
            ))}
          </select>
        </Col>
        <Col md={8} className="d-flex justify-content-end">
          <div className="">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            {/* <button onClick={() => setFormPopup(!formPopup)} className='btn btn-outline-secondary border-radius me-2'><i className='fas fa-filter'></i></button> */}
            {/* CSV download btn */}
            {/* <CSVLink
                            className='border-radius btn text-white me-2 btn-success'
                            filename="gst_ztpl.csv"
                            data={csvData}>
                            <i className="fas fa-download me-2 icon-size"></i> Export CSV
                        </CSVLink> */}

            {/* <button className='border-radius btn text-white me-2 btn-success'>
                            <i className="fas fa-download me-2 icon-size"></i> Export CSV    
                        </button> */}

            {/* <button onClick={() => navigate(-1)} className="border-radius btn btn-red"><i className='dripicons-cross me-2 icon-center'></i>CANCEL</button> */}
          </div>
        </Col>
      </Row>

      <div className="position-relative">
        {/* <Table className='table table-bordered mt-3' {...getTableProps()}>
                    <thead className={`${fixedContent ? 'fixed-setting-header' : ''} fix-gst-header`}>
                        {
                            headerGroups.map((headerGroup, i) => (
                                <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                                    {
                                        headerGroup.headers.map((column, index) => (
                                            <th key={index} className={`t-col-${index + 1} ${column.className}`} {...column.getHeaderProps()}>{column.render("Header")}
                                               
                                            </th>
                                        ))
                                    }
                                </tr>
                            ))
                        }
                    </thead>

                    <tbody className="fix-gst-header" {...getTableBodyProps()}>
                        {
                            page.map((row, i) => {
                                prepareRow(row);
                                return (
                                    <tr className='row-hover' {...row.getRowProps()} key={i}>
                                        {
                                            row.cells.map((cell, index) => {
                                                return <td key={index} className={`t-col-${index + 1} ${cell.column.className}`} {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                                            })
                                        }
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </Table> */}
        <Table className="table table-bordered" {...getTableProps()}>
          <thead
            className={`${
              fixedContent ? "fixed-punch-details-header" : "fix-table-header"
            } `}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => {
                  const classNames = column.className
                  return (
                    <th
                      key={index}
                      className={` col-t-${index + 1} ${classNames}`}
                      // {...column.getHeaderProps()}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      <div
                        className={`position-relative d-flex ${
                          column.isShortIcon
                            ? "justify-content-between"
                            : "justify-content-center"
                        }`}
                      >
                        {index === 0 && <span></span>}
                        <span
                          style={{
                            position: index === 0 ? "absolute" : "",
                            left: index === 0 ? "45%" : "",
                          }}
                        >
                          {column.render("Header")}
                        </span>
                        {column.isShortIcon ? (
                          <span
                            style={{
                              position: index != 0 ? "absolute" : "",
                              right: index != 0 ? "0" : "",
                            }}
                            onClick={() =>
                              column.getSortByToggleProps().onClick()
                            }
                          >
                            <i
                              title="Ascending"
                              className={`bi bi-arrow-up ms-1 info-icon ${
                                column.isSorted && !column.isSortedDesc
                                  ? "text-dark"
                                  : ""
                              }`}
                            ></i>
                            <i
                              title="Descending"
                              className={`bi bi-arrow-down info-icon ${
                                column.isSorted && column.isSortedDesc
                                  ? "text-dark"
                                  : ""
                              }`}
                            ></i>
                          </span>
                        ) : null}
                      </div>
                    </th>
                  )
                })}
              </tr>
            ))}
          </thead>

          <tbody className="fix-punch-table-body" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row)
              const { did_col: did, pwd_col: pwd } = row.original
              const status = row.original.status_name

              let backgroundStyle = {}

              const priority = row.original.priority_col

              return (
                <tr {...row.getRowProps()} key={i} style={backgroundStyle}>
                  {row.cells.map((cell, index) => (
                    <td
                      key={index}
                      className={`t-col-${index + 1} ${cell.column.className} ${
                        priority == "High" ? "highPriority" : ""
                      }`}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </Table>
        {/* {
                    formPopup ?
                        <div className='p-4' id='gst_filter_popup'>
                            <Form>
                                <Row className='align-items-end'>
                                    <div className="col-md-3">
                                        <label htmlFor="">Start Date</label>
                                        <input type="date" className='form-control border-radius' />
                                    </div>

                                    <div className="col-md-3">
                                        <label htmlFor="">End Date</label>
                                        <input type="date" className='form-control border-radius' />
                                    </div>

                                    <div className="col-md-3">
                                        <label htmlFor="">By</label>
                                        <select type="date" className='form-select border-radius'>
                                            <option value="Nothing Selected">Nothing Selected</option>
                                            <option value="Debit">Debit</option>
                                            <option value="Credit">Credit</option>
                                        </select>
                                    </div>

                                    <div className='text-center pe-0 col-md-3'>
                                        <button className='btn border-radius btn-purple me-3'>
                                            <i className="fas fa-search me-2"></i>
                                            Search
                                        </button>
                                        <button className='btn border-radius btn-red'
                                            onClick={(e) => {
                                                e.preventDefault()
                                                setFormPopup(!formPopup)
                                            }}
                                        ><i className="dripicons-cross me-1 icon-center"></i> Clear</button>
                                    </div>
                                </Row>
                            </Form>
                            <i className='bi bi-triangle-fill pop-icon'></i>
                        </div> : null
                } */}
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPag={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>
    </div>
  )
}

const PunchScreen = () => {
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center emp-id",
      },
      {
        Header: "Employee Code",
        accessor: "employee_code",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center emp-code",
      },
      {
        Header: "Punch ID",
        accessor: "punch_id",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center puch-id",
      },
      {
        Header: "Employee Name",
        accessor: "employee_name",
        isInfoIcon: false,
        isShortIcon: true,
        className: "emp-name",
      },
      {
        Header: "Department",
        accessor: "department",
        isInfoIcon: false,
        isShortIcon: true,
        className: "department",
      },
      {
        Header: "Designation",
        accessor: "designation",
        isInfoIcon: false,
        isShortIcon: true,
        className: "Designation",
      },
      {
        Header: "Action",
        accessor: "action",
        className: "text-center action",
        Cell: cellProps => {
          return (
            <div>
              <Link
                // to={`${configure.appUrl}punch-details`}
                to={`${configure.appUrl}punch-preview`}
                title="view"
                className="btn btn-sm btn-outline-secondary me-1"
              >
                <i className="bi bi-clipboard-fill"></i>
              </Link>
            </div>
          )
        },
      },
    ],
    []
  )

  const data = [
    {
      id: 1,
      employee_code: "54fd",
      punch_id: "54fd",
      employee_name: "Eva",
      department: "Marketing",
      designation: "Marketing Executive",
    },
    {
      id: 2,
      employee_code: "54fd",
      punch_id: "54fd",
      employee_name: "Ryan",
      department: "Marketing",
      designation: "Marketing Executive",
    },
    {
      id: 3,
      employee_code: "54fd",
      punch_id: "54fd",
      employee_name: "Evan",
      department: "Marketing",
      designation: "Marketing Executive",
    },
    {
      id: 4,
      employee_code: "54fd",
      punch_id: "54fd",
      employee_name: "Rahul",
      department: "Development",
      designation: "Software Developer",
    },
    {
      id: 5,
      employee_code: "54fd",
      punch_id: "54fd",
      employee_name: "Divyanch",
      department: "Development",
      designation: "Software Developer",
    },
    {
      id: 6,
      employee_code: "54fd",
      punch_id: "54fd",
      employee_name: "eva",
      department: "Marketing",
      designation: "Marketing Executive",
    },
    {
      id: 7,
      employee_code: "54fd",
      punch_id: "54fd",
      employee_name: "eva",
      department: "Marketing",
      designation: "Marketing Executive",
    },
  ]

  return (
    <>
      {/* <div>
        <Row className="ms-0 pe-0">
          <Col lg={12} className="p-0">
            <Card>
              <CardBody>
                <TableContainer columns={columns} data={data} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div> */}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={"Payroll Management"}
            breadcrumbItem={"Punch Details"}
          />

          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <TableContainer columns={columns} data={data} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default PunchScreen
